const MAX_RECORDS = 100;
const ALLOWED_FIELDS = new Set([
  "operation",
  "succeeded",
  "sourceVersion",
  "targetVersion",
  "migrationAttempted",
  "migrationSucceeded",
  "failureStage",
  "safeToContinue",
  "sessionActivated",
  "persistenceState",
  "code",
]);
let records = [];

const isScalar = (value) => value == null || ["string", "number", "boolean"].includes(typeof value);
const sanitize = (event = {}) =>
  Object.entries(event).reduce((result, [key, value]) => {
    if (!ALLOWED_FIELDS.has(key) || !isScalar(value)) return result;
    return { ...result, [key]: value };
  }, {});
const clone = (value) => ({ ...value });

export const cryptoTelemetry = {
  record(event) {
    const entry = Object.freeze({ timestamp: new Date().toISOString(), ...sanitize(event) });
    records = [...records.slice(-(MAX_RECORDS - 1)), entry];
    return clone(entry);
  },
  getRecords() {
    return records.map(clone);
  },
  clear() {
    records = [];
  },
};
